// ServiceData.js
export const services = [
  {
    id: 1,
    title: "Thermal Insulation Services",
    mainImage: "images/landing/img-1.png",
    description:
      "Comprehensive thermal insulation solutions including coating, calculations, and analysis",
    features: [
      "Thermal Insulation Coating",
      "Thermal Insulation Calculation Details",
      "Thermal Analysis & Optimization",
      "Energy Efficiency Solutions",
    ],
    additionalFeatures: [
      "Thermal Insulation Calculation & Design",
      "Thermal Energy Loss Prevention",
      "Material Selection & Coating Applications",
    ],
    icon: "🌡️",
    extendedDetails:
      "Thermal insulation and coating services help protect against temperature variations and energy loss in industrial settings.",
    detail: "detail-service",
    gridArea: "span 1 / span 4",
    gallery: [
      "images/landing/img-1.png",
      "images/landing/img-1.png",
      "images/landing/img-1.png",
      "images/landing/img-1.png",
      "images/landing/img-1.png",
    ],
  },
  {
    id: 2,
    title: "Corrosion Under Insulation Services",
    mainImage: "images/landing/service_page/served/corrosion-service.jpg",
    description:
      "Advanced protection against corrosion under insulation with monitoring systems",
    features: [
      "CUI Prevention Systems",
      "Rectifier Transformer Installation",
      "Monitoring & Maintenance",
      "Prevention Strategies",
    ],
    additionalFeatures: [
      "Corrosion Mapping",
      "Gecko Robotic Inspection",
      "Pipeline Current Mapper (PCM)",
      "Direct Assessment Inspection",
    ],
    icon: "🛡️",
    extendedDetails:
      "Our comprehensive system helps detect and prevent corrosion issues in early stages with advanced monitoring solutions.",
    detail: "detail-service",
    gridArea: "span 1 / span 2",
    gallery: [
      "images/landing/service_page/served/corrosion-service.jpg",
      "images/landing/service_page/served/corrosion-service.jpg",
      "images/landing/service_page/served/corrosion-service.jpg",
      "images/landing/service_page/served/corrosion-service.jpg",
      "images/landing/service_page/served/corrosion-service.jpg",
    ],
  },
  {
    id: 3,
    title: "System Online Monitoring",
    mainImage: "images/landing/service_page/served/online-monitoring.png",
    description:
      "Cathodic Protection Corrosion Monitoring System online using the Internet network",
    features: [
      "Real-time Monitoring",
      "Data Analytics",
      "Alert Systems",
      "Performance Reports",
    ],
    additionalFeatures: [
      "Remote Cathodic Protection Monitoring",
      "Data Logging (INTLOG)",
      "Current Interrupter GPS Synchronize",
    ],
    icon: "📊",
    extendedDetails:
      "24/7 online monitoring system providing real-time insights and alerts for your cathodic protection systems.",
    detail: "detail-service",
    gridArea: "span 1 / span 3",
    gallery: [
      "images/landing/service_page/served/online-monitoring.png",
      "images/landing/service_page/served/online-monitoring.png",
      "images/landing/service_page/served/online-monitoring.png",
      "images/landing/service_page/served/online-monitoring.png",
      "images/landing/service_page/served/online-monitoring.png",
    ],
  },
  {
    id: 4,
    title: "Cathodic Protection Services",
    mainImage: "images/landing/service_page/served/cathodic-protections.jpg",
    description: "Complete ICCP & SACP solutions for infrastructure protection",
    features: [
      "ICCP System Design & Installation",
      "SACP Implementation",
      "System Monitoring",
      "Maintenance Programs",
    ],
    additionalFeatures: [
      "Transformer Rectifier Installation",
      "Junction Box Installation",
      "Holiday Test (CIPS & DCVG)",
      "Survey & Desain Cathodic Protection",
      "Remote Monitoring Inspection",
    ],
    icon: "⚡",
    extendedDetails:
      "Providing end-to-end cathodic protection solutions including design, installation, and maintenance.",
    detail: "detail-service",
    gridArea: "span 1 / span 3",
    gallery: [
      "images/landing/service_page/served/cathodic-protections.jpg",
      "images/landing/service_page/served/cathodic-protections.jpg",
      "images/landing/service_page/served/cathodic-protections.jpg",
      "images/landing/service_page/served/cathodic-protections.jpg",
      "images/landing/service_page/served/cathodic-protections.jpg",
    ],
  },
  /* {
    id: 5,
    title: "Corrosion Inspection Services",
    mainImage: "images/landing/service_page/served/corrosion-service.jpg",
    description:
      "Comprehensive inspection services to detect and analyze potential corrosion issues",
    features: [
      "Close Interval Potential Survey (CIPS)",
      "Direct Current Voltage Gradient (DCVG)",
      "Pipeline Current Mapper (PCM)",
      "Holiday Detection",
      "On-site Corrosion Testing",
    ],
    additionalFeatures: [
      "Corrosion Mapping & Assessment",
      "Gecko Robotic Inspection",
      "Chemical & Material Analysis",
    ],
    icon: "🔍",
    extendedDetails:
      "Expert inspection services that identify and evaluate corrosion threats before they become critical issues.",
    detail: "detail-service",
    gridArea: "span 1 / span 2",
    gallery: [
      "images/landing/service_page/served/inspection-service.jpg",
      "images/landing/service_page/served/inspection-service.jpg",
      "images/landing/service_page/served/inspection-service.jpg",
      "images/landing/service_page/served/inspection-service.jpg",
      "images/landing/service_page/served/inspection-service.jpg",
    ],
  },
  {
    id: 6,
    title: "Consultation & Survey Services",
    mainImage: "images/landing/service_page/served/corrosion-service.jpg",
    description:
      "Technical consultation and survey services for corrosion protection and energy savings",
    features: [
      "Survey & Desain Cathodic Protection",
      "Thermal Insulation Calculation & Design",
      "Thermal Analysis",
      "Risk Assessment & Mitigation Planning",
    ],
    additionalFeatures: [
      "Remote Monitoring System Consultation",
      "Feasibility Study for Corrosion Protection",
    ],
    icon: "📝",
    extendedDetails:
      "Professional consultation services to help you implement the most effective corrosion protection and energy efficiency strategies.",
    detail: "detail-service",
    gridArea: "span 1 / span 4",
    gallery: [
      "images/landing/service_page/served/consultation-service.jpg",
      "images/landing/service_page/served/consultation-service.jpg",
      "images/landing/service_page/served/consultation-service.jpg",
      "images/landing/service_page/served/consultation-service.jpg",
      "images/landing/service_page/served/consultation-service.jpg",
    ],
  },
  {
    id: 7,
    title: "Materials & Development",
    mainImage: "images/landing/service_page/served/corrosion-service.jpg",
    description:
      "Supply of high-quality materials and development of cathodic protection solutions",
    features: [
      "Material Preparation & Chemical Analysis",
      "Instrumentation Laboratory",
      "Development of Cathodic Protection Materials",
    ],
    additionalFeatures: [],
    icon: "🔬",
    extendedDetails:
      "Providing specialized materials and innovative solutions for effective cathodic protection and thermal insulation applications.",
    detail: "detail-service",
    gridArea: "span 1 / span 6",
    gallery: [
      "images/landing/service_page/served/materials-dev.jpg",
      "images/landing/service_page/served/materials-dev.jpg",
      "images/landing/service_page/served/materials-dev.jpg",
      "images/landing/service_page/served/materials-dev.jpg",
      "images/landing/service_page/served/materials-dev.jpg",
    ],
  }, */
];

export const engineeringServices = [
  "Cathodic Protection Design & Calculation",
  "Pipeline Current Mapping",
  "Cathodic Protection Testing",
  "Close Interval Potential Survey (CIPS)",
  "Direct Current Voltage Gradient (DCVG)",
  "Pipeline Current Mapper (PCM)",
  "Pipeline Holiday Tester",
  "External Corrosion Direct Assessment (ECDA)",
  "Pipeline Risk Assessment",
  "Thermal Insulation Coating",
  "Thermal Insulation Calculation & Design",
  "Corrosion Mapping & Assessment",
  "Remote Monitoring System Implementation",
  "Feasibility Study for Corrosion Protection",
  "Material Selection & Analysis",
];

export const materialTypes = [
  {
    name: "Transformer Rectifiers",
    description: "Portable TR, Oil/Air Cooled TR, Automatic Controlled TR",
    image: "/images/landing/product_page/kerikil-1.jpg",
  },
  {
    name: "Impressed Current Anodes",
    description: "Ti-MMO Anode, Fe-Si-Cr Anode",
    image: "/images/landing/product_page/kerikil-2.jpg",
  },
  {
    name: "Sacrificial Anodes",
    description: "Zinc Anode, Aluminum Anode, Magnesium Anode",
    image: "/images/landing/product_page/kerikil-3.jpg",
  },
  {
    name: "Reference Electrodes",
    description: "Cu/CuSO4 Electrode, Ag/AgCl Electrode",
    image: "/images/landing/product_page/kerikil-4.jpg",
  },
  {
    name: "Groundbed Backfill",
    description: "AdhimCoke",
    image: "/images/landing/product_page/kerikil-5.jpg",
  },
  {
    name: "Cathodic Protection Cables",
    description: "Kynar/HMWPE Cables, XLPE/PVC Cables",
    image: "/images/landing/product_page/kerikil-6.jpg",
  },
  {
    name: "Inspection Tools",
    description: "Current Interrupter GPS Synchronize, Data Logging (INTLOG)",
    image: "/images/landing/product_page/kerikil-7.png",
  },
  {
    name: "Lithium/Magnesium Powder",
    image: "/images/landing/product_page/kerikil-8.jpg",
  },
];
